import { Component, OnDestroy, OnInit } from '@angular/core';
import { CoreService, SettingsService } from 'src/app/shared';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss']
})
export class FullLayoutComponent implements OnInit, OnDestroy {

  menus = [];
  hideMenu = false;
  fullscreen = false;
  subFullS:any;

  constructor(private coreService: CoreService, 
    private settingsService: SettingsService) { }

  ngOnInit() {
    this.loadMenu ();
   this.subFullS =  this.coreService.fullScreenSubject.subscribe (res=>{
      this.fullscreen  = res;
    });
  }

  ngOnDestroy (){
    if (this.subFullS){
      this.subFullS.unsubscribe();
    }
  }

  loadMenu (){
    this.settingsService
    .getMenu()
    .pipe(first())
    .subscribe(res => {
      this.menus = res["menu"];
      this.hideMenu = this.menus.length <=1 ;
    });
  }

}
